<template>
    <div>
        <CLoader :pConfigLoad="ConfigLoad">
            <template slot="BodyFormLoad">
                <div class="row">
					<div class="col-lg-3">
						<div class="avatar-upload-histequipo">
                            <div v-show="!Disabled" class="avatar-edit">
                                <input :disabled="Disabled" id="file" @change="CambiarImagen($event)" ref="file" type="file" name="file" accept=".png, .jpg, .jpeg">
                                <label for="file"></label>
                            </div>
                            <div class="avatar-edit2">
                                <button type="button" data-backdrop="static"
                                data-toggle="modal"
                                data-target="#imagenequipo" @click="ZoomImagen(ImagenAMostrar)">
                                    <i class="fas fa-search"></i>
                                </button>
                            </div>
                            <!-- <div v-if="BndImagenEquipo!=0" class="avatar-edit3">
                                <button type="button" @click="GuardarImagenEquipo">
                                    <i class="fas fa-save"></i>
                                </button>
                            </div> -->
                            <div class="avatar-preview">
                                <div id="imagePreview" :style="'background-image: url('+ImagenAMostrar+');'" :src="ImagenAMostrar">
                                </div>
                            </div>
                        </div>
					</div>
					<div class="col-lg-9">
						<div class="row">
							<div class="col-lg-3">
                    		    <label >SKU </label>
                    		    <input :disabled="Disabled" type="text" v-model="Equipo.Codigo" class="form-control" placeholder="SKU" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Codigo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
                    		<div class="col-lg-3">
                    		    <label >Ítem </label>
                    		    <input :disabled="Disabled" type="text" v-model="Equipo.Item" class="form-control" placeholder="Ítem" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Item" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label for="">Unidad</label>
								<input :disabled="Disabled" type="text" class="form-control" v-model="Equipo.Unidad" placeholder="Unidad">
								<label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Unidad" :Mensaje="this.errorvalidacion.Unidad[0]"></Cvalidation></label>
							</div>
							<div class="col-lg-3">
                    		    <label >Marca </label>
                    		    <input :disabled="Disabled" type="text" v-model="Equipo.Marca" class="form-control" placeholder="Marca" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Marca" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
						</div>
						<div class="row">
							<div class="col-lg-3">
                    		    <label >Modelo </label>
                    		    <input :disabled="Disabled" type="text" v-model="Equipo.Modelo" class="form-control" placeholder="Modelo" />
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Modelo" :Mensaje="'Campo obligatorio'"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
                    		    <label >Costo Unitario</label>
                    		    <vue-numeric :disabled="Disabled" placeholder="$ 0.00"  :minus="false"  class="form-control "  currency="$" separator="," :precision="2" v-model="Equipo.Precio"></vue-numeric>
                    		    <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Precio" :Mensaje="this.errorvalidacion.Precio[1]"></Cvalidation></label>
                    		</div>
							<div class="col-lg-3">
								<label for="">Stock</label>
								<select :disabled="Disabled" v-model="Equipo.Stock" class="form-control">
									<option value="">- Stock -</option>
									<option value="stock">Stock</option>
									<option value="bajo pedido">Bajo Pedido</option>
								</select>
								<!-- <input @input="CambiarFechaStock" type="number" class="form-control" v-model="Equipo.Stock" placeholder="Stock"> -->
								<!-- <label id="lblmsuser" style="color:red"><Cvalidation v-if="this.errorvalidacion.Stock" :Mensaje="this.errorvalidacion.Stock[0]"></Cvalidation></label> -->
							</div>
							<div class="col-lg-3">
								<label for="">Archivo</label>
                        		<div class="custom-file-input-image">
                        		    <input :disabled="Disabled" @change="SubirArchivo()" type="file" accept="application/pdf" ref="archivo" class="custom-file-input" id="validatedCustomFile" required>
                        		    <input :disabled="Disabled" type="text" v-model="NombreArchivo" class="form-control">
                        		    <button :disabled="Disabled" type="button" class=""><i class="fas fa-paperclip"></i></button>
                        		</div>
							</div>
						</div>
					</div>
                    <!--fin col-6-->
                </div>
				<div class="row">
					<div class="col-lg-12">
						<label for="">Descripción</label>
						<textarea :disabled="Disabled" v-model="Equipo.Nombre" cols="30" rows="2" class="form-control" placeholder="Descripción"></textarea>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col-lg-12">
						<label for="">Movimientos</label>
						<textarea :disabled="Disabled" v-model="Equipo.Movimientos" cols="30" rows="2" class="form-control" placeholder="Movimientos"></textarea>
					</div>
				</div>
                <!--Fin body del panel-->
            </template>
        </CLoader>
		<Modal :Showbutton="false" :NameModal="'imagenequipo'" :Nombre="'Imagen'" :TipoM="2">
            <template slot="Form">
				<div class="form-row justify-content-center align-items-center">
					<img :src="ImagenAMostrar" alt="Aún no hay una imagen para mostrar" class="img-thumbnail">
				</div>
			</template>
        </Modal>
    </div>

</template>

<script>
import Cbtnsave from '@/components/Cbtnsave.vue'
import Clist from '@/components/Clist.vue';
import Cvalidation from '@/components/Cvalidation.vue'
import Modal from '@/components/Cmodal.vue';
import Config from "@/helpers/VarConfig.js";

export default {
    name:'Form',
    props:['NameList','poBtnSave','pDisabled'],
    data() {
        return {
            Modal:true,//Sirve pra los botones de guardado
            FormName:'Equipo',//Sirve para donde va regresar
            ConfigLoad:{
                ShowLoader:true,
                ClassLoad:true
            },
            Equipo:{            
                IdEquipoCot:0,
                Codigo:"",
                Nombre:"",
				Marca:"",
				Modelo:"",
                Precio:"",
				Item:"",
				Unidad:"",
				Stock:'',
				Movimientos:"",
				Foto:"",
				Archivo:""
				// FechaStock:""
            },
            urlApi:"cotizacion_equipodistribuidor/recovery",
            errorvalidacion:[],
			EmitSeccion:this.poBtnSave.EmitSeccion,
			Disabled:false,
			ValidElement:Config.validImage2m,
			ImagenAMostrar:'',
			NombreArchivo:'',
			// FechaStockOriginal:"",
			// StockOriginal:"",
        }
    },
    components:{
        Cbtnsave,
        Clist,Cvalidation,Modal
    },
    methods :
    {
    
       async Guardar()
        {
             //deshabilita botones
            this.poBtnSave.toast=0; 
            this.poBtnSave.disableBtn=true;
			let image=this.$refs.file.files[0];
			let file=this.$refs.archivo.files[0];
			let formData=new FormData();
			formData.set('IdEquipoCot',this.Equipo.IdEquipoCot);
			formData.set('Nombre',this.Equipo.Nombre);
			formData.set('Precio',this.Equipo.Precio);
			formData.set('Codigo',this.Equipo.Codigo);
			formData.set('Marca',this.Equipo.Marca);
			formData.set('Modelo',this.Equipo.Modelo);
			formData.set('Unidad',this.Equipo.Unidad);
			formData.set('Item',this.Equipo.Item);
			formData.set('Stock',this.Equipo.Stock);
			formData.set('Movimientos',this.Equipo.Movimientos);
			formData.set('Foto',this.Equipo.Foto);
			formData.set('Archivo',this.Equipo.Archivo);
			formData.append('FotoFile',image);
			formData.append('ArchivoFile',file);
            await this.$http.post(
                'cotizacion_equipodistribuidor/post',
                formData,
				{
                headers:{
                    'Content-Type':'multipart/form-data'
                }  
            }
            ).then( (res) => {
                this.poBtnSave.disableBtn=false;  
                this.poBtnSave.toast=1;
                $('#'+this.EmitSeccion).modal('hide');
                this.bus.$emit('List_'+this.EmitSeccion);

            }).catch( err => {
                this.errorvalidacion=err.response.data.message.errores;
                this.poBtnSave.disableBtn=false;
                this.poBtnSave.toast=2;  

            });
       
        },
         Limpiar()
        {
            this.Equipo.IdEquipoCot=0;
            this.Equipo.Nombre="";
			this.Equipo.Marca="";
			this.Equipo.Modelo="";
            this.Equipo.Codigo="";
            this.Equipo.Precio="";
			this.Equipo.Item="";
			this.Equipo.Unidad="";
			this.Equipo.Movimientos="";
			this.Equipo.Stock='';
			this.Equipo.Foto='';
			this.Equipo.Archivo='';
			// this.Equipo.FechaStock='';
			// this.StockOriginal=0;
			// this.FechaStockOriginal=new Date();
            this.errorvalidacion=[];
			this.ImagenAMostrar='';
			this.NombreArchivo='';
			this.$refs.file.value=null;
            
        },
        get_one()
        {
            this.$http.get(
                this.urlApi,
                {
                    params:{IdEquipoCot: this.Equipo.IdEquipoCot}
                }
            ).then( (res) => {
                this.Equipo=res.data.data.equipocot;
				this.ImagenAMostrar=res.data.data.ruta+this.Equipo.Foto;
				this.NombreArchivo=res.data.data.equipocot.Archivo;
				// if (res.data.data.equipocot.FechaStock!=null) {
				// 	let formatedDate = res.data.data.equipocot.FechaStock.replace(/-/g, "\/");
                // 	this.Equipo.FechaStock=new Date(formatedDate)
				// 	this.FechaStockOriginal=new Date(formatedDate);	
				// }
				// else{
				// 	this.Equipo.FechaStock=new Date();
				// 	this.FechaStockOriginal=new Date();
				// }
				// this.StockOriginal=res.data.data.equipocot.Stock;
            }).finally(()=>{
                this.ConfigLoad.ShowLoader=false;
            });
        },
		CambiarImagen(target){
            this.$uploadImagePreview(target,this.ValidElement, Array('Img','imagePreview'));
        },
		ZoomImagen(Imagen){
            if (this.$refs.file.files[0]!=undefined) {
				let ImagenPreview=document.getElementById("imagePreview");
				const Estilos=window.getComputedStyle(ImagenPreview);
				let CadenaBase=Estilos.backgroundImage;
				let Url=CadenaBase.slice(5,-2);
				this.ImagenAMostrar=Url;
			}
			else{
				this.ImagenAMostrar=Imagen;
			}
        },
		SubirArchivo(){
			const image = this.$refs.archivo.files[0];

            var FileSize = image.size / 1024 / 1024; // in MB
            if (FileSize > 5) {
                this.$toast.info('Solo se puede subir archivos menores a 5 MB');
                const  input  = this.$refs.archivo;
                input .type = 'text'
                input .type = 'file';
                return false;
            }
                        
            var allowedExtensions = /(\.pdf|\.PDF)$/i;
            if(!allowedExtensions.exec(image.name)){
                this.$toast.info('Extenciones permitidas .pdf');
                const  input  = this.$refs.archivo;
                input.type = 'text'
                input.type = 'file';
                this.NombreArchivo='Elegir archivo (5MB)';
                return false;
            }

            this.NombreArchivo=image.name;
		}
		// CambiarFechaStock(){
		// 	if (this.Equipo.Stock!=this.StockOriginal) {
		// 		this.Equipo.FechaStock=new Date();
		// 	}
		// 	else{
		// 		this.Equipo.FechaStock=this.FechaStockOriginal;
		// 	}
		// }

    },
    created() {
        
        this.bus.$off('Save_'+this.EmitSeccion);
        this.bus.$off('NewModal_'+this.EmitSeccion);

        this.bus.$on('Save_'+this.EmitSeccion,()=>
        {
           this.Guardar();
        });
        
        //Este es para modal
        this.bus.$on('NewModal_'+this.EmitSeccion,(data,Id)=> 
        {   
            this.ConfigLoad.ShowLoader=true;
            this.poBtnSave.disableBtn=false; 
             this.Limpiar();
            if (Id>0)
            {
                this.Equipo.IdEquipoCot=Id;
                this.get_one();
            }
            else{
                this.ConfigLoad.ShowLoader=false;
            }
            this.bus.$emit('Desbloqueo',false);
            
        });
       
    },
	mounted() {
		if (this.pDisabled!=undefined) {
			this.Disabled=this.pDisabled;
		}
	},
	computed:{
        typeCalendar:function(){
            return 'single';
        }
    }
}
</script>

<style>

</style>
